export default function firebaseGermanErrorMessages(error){
    switch(error.code){
        case 'permission-denied':
            return 'Fehlende Berechtigung';
        default:
            return error.message;
    }
}